module.exports = __webpack_public_path__ + "img/worldnet4.1a17600a.png";